import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { compose } from "redux";

import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { fetchCorrectible, fetchCorrectibleFormer, fetchCorrectibleAgent, submitCorrectible, submitCorrectibleForAuthorizedAgent, submitCorrectibleFormer } from "./actions";
import { fetchRequestHistory, fetchFormerRequestHistory } from "../DownloadAndDelete/actions";
import { fetchCustomerHistory } from "../AuthorizedAgent/actions";
import { setA11yContent } from "../NavigationHelper/actions";
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import RectangleLoader from "common-components/RectangleLoader";

import { media } from "utils/style";
import { TitleLockup } from "@vds/type-lockups";
import { TextLink } from "@vds/buttons";

import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { checkAMLob } from "utils/checkAMLob";

import { CorrectiblePageAccordion as Accordion } from "common-components";
import { Select as ReactSelect } from "common-components/FormContent";
import { DropdownSelect } from "@vds/selects";
import AlertBanner from "common-components/Alert";

import FetchPageContent from "../../../hoc/FetchPageContent";
import RepFlowModal from "./RepFlowModal/RepFlowModal";
import { formerandGuestCloseCaseId, breadcrumbsLink } from "../FormerCustomer/actions"

import "./Correctible.css";

class CorrectibleData extends Component {

  state = {
    showRepModal: false,
    editedElements: [],
    selectedFormerAccount: [],
    agentIndex: "",
    agentName: "",
    selectedFormerBox: false
  };



  componentDidMount() {
    const lobInfo = this.getLOB();
    const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
    if ("agent" === lobInfo) {
      this.props.fetchCustomerHistory(this.props.location.state.agentSelectedCustomer)
    } else if (formerIdInfo) {
      this.props.fetchFormerRequestHistory(accountList[0])
    } else {
      this.props.fetchRequestHistory();
    }

    const { pageContent } = this.props;

    if (checkNestedObject(pageContent, "sections", [2], "breadCrumbs")) {
      this.props.setBreadcrumbList([
        { label: pageContent.sections[2].breadCrumbs.landingPage, path: "/privacy/secure/your-data" },
        { label: pageContent.sections[2].breadCrumbs.yourCorrectibleData, path: "/privacy/secure/your-correctible" }
      ]);
    }

    this.props.setA11yContent("your correctible", pageContent.sc_pagetitle, pageContent.seo_description);


    if (formerIdInfo && formerIdInfo.trim().length > 0) {
      const formerAccountIdentifiers = window.reactGlobals.formerAcctsInfo.accountIdentifiers ? window.reactGlobals.formerAcctsInfo.accountIdentifiers : [];
      let valueObj = {};
      if (formerAccountIdentifiers && formerAccountIdentifiers.length > 0) {
        formerAccountIdentifiers.forEach(accID => {
          valueObj[accID.identifier] = accID.value;
        })
      }
      var data = {
        caseId: valueObj['caseId'] ? valueObj['caseId'] : null,
        email: valueObj['emailId'] ? valueObj['emailId'] : null,
        intent: "Correct",
        serviceType: "former"
      }
      this.props.setBreadcrumbList([]);
      if (data.caseId) {
        this.props.formerandGuestCloseCaseId(data)
      }

      if (accountList && accountList.length > 0) {
        this.setState(prevState => ({
          showRepModal: prevState.showRepModal,
          data: { ...prevState.data, ...prevState.requestStatus },
          editedElements: [...prevState.editedElements],
          selectedFormerAccount: [accountList[0]]
        }));
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.getLOB() === "agent") {
      if (true === this.state.authorizedAgentEditedElementUpdateStatus && true === this.state.showEditableForm) {
        this.hideEditableFormForAuthorizedAgent();
      }
    }
  }

  hideEditableFormForAuthorizedAgent = () => {
    this.setState({ showEditableForm: false });
  }

  showEditableFormForAuthorizedAgent = (elementId, element, subCategoryIdInfo, categoryIdInfo) => {
    this.setState(prevState => ({
      showRepModal: prevState.showRepModal,
      data: { ...prevState.data, ...prevState.requestStatus },
      editedElements: [...prevState.editedElements],
      selectedFormerAccount: [...prevState.selectedFormerAccount],
      authorizedAgentEditedElementId: elementId,
      authorizedAgentEditedElement: element,
      authorizedAgentEditedElementIdCategory: categoryIdInfo,
      authorizedAgentEditedElementIdSubCategory: parseInt(subCategoryIdInfo),
      authorizedAgentEditedElementUpdateStatus: false,
      showEditableForm: true
    }));

  };


  submitAuthorizedAgentEditedFormData = (evt, categoryId, elementId, elementName) => {
    evt.preventDefault();

    if (this.props.form.authAgentCorrectionInfo.values) {
      const agentEditedData = Object.keys(this.props.form.authAgentCorrectionInfo.values).filter(keyInfo => keyInfo.startsWith(elementId));

      if (agentEditedData && agentEditedData.length > 0) {
        const agentEditedDataFormValues = agentEditedData.map(data => {
          const fieldName = data.replace(elementId + "_", "");
          const fieldValue = this.props.form.authAgentCorrectionInfo.values[data];
          return (
            fieldName + ":" + fieldValue
          )
        }).join(",");

        this.setState({ authorizedAgentEditedElementUpdateStatus: false });
        this.props.handleModalState(false);
        this.props.submitCorrectibleForAuthorizedAgent(categoryId, elementId, elementName, agentEditedDataFormValues, this.props.agentSelectedCustomer.mtn)
          .then(() => {
            if (!this.props.errorInfo) {
              this.setState(prevState => ({
                showRepModal: false,
                data: { ...prevState.data, requestStatus: "Request in-progress" },
                editedElements: [...prevState.editedElements, categoryId + ":" + elementId + "-" + elementName],
                selectedFormerAccount: [...prevState.selectedFormerAccount],
                authorizedAgentEditedElementId: prevState.authorizedAgentEditedElementId,
                authorizedAgentEditedElement: prevState.authorizedAgentEditedElement,
                authorizedAgentEditedElementIdCategory: prevState.authorizedAgentEditedElementIdCategory,
                authorizedAgentEditedElementIdSubCategory: prevState.authorizedAgentEditedElementIdSubCategory,
                authorizedAgentEditedElementUpdateStatus: true
              }));
            }
            else {
              this.setState(prevState => ({
                showRepModal: false,
                data: { ...prevState.data, requestStatus: "" },
                editedElements: [...prevState.editedElements],
                selectedFormerAccount: [...prevState.selectedFormerAccount],
                authorizedAgentEditedElementId: prevState.authorizedAgentEditedElementId,
                authorizedAgentEditedElement: prevState.authorizedAgentEditedElement,
                authorizedAgentEditedElementIdCategory: prevState.authorizedAgentEditedElementIdCategory,
                authorizedAgentEditedElementIdSubCategory: prevState.authorizedAgentEditedElementIdSubCategory,
                authorizedAgentEditedElementUpdateStatus: false
              }));
            }
          });


      }
    }

  }

  showRepFlowModal = (categoryId, subCategoryId, elementIdx, elementId, elementName) => {
    this.props.handleModalState(true);
    //this.props.clearErrors();
    this.setState({
      showRepModal: true,
      data: { categoryId, subCategoryId: parseInt(subCategoryId), elementIdx, elementId, elementName },
      editedElements: [...this.state.editedElements],
      selectedFormerAccount: [...this.state.selectedFormerAccount]
    });
  };

  showRepFlowModalForAuthorizedAgent = () => {
    this.props.handleModalState(true);
    this.setState({ showRepModal: true })
  }

  cancelClickHandler = () => {
    this.props.handleModalState(false);
    this.setState(prevState => ({
      showRepModal: false,
      data: {},
      editedElements: [...prevState.editedElements],
      selectedFormerAccount: [...prevState.selectedFormerAccount],
      authorizedAgentEditedElementId: "",
      authorizedAgentEditedElement: {},
      showEditableForm: false
    }));

    if (this.getLOB() === "agent") {
      document.getElementById('content' + this.state.agentIndex + this.state.agentName).style.display = "";
      document.getElementById('button' + this.state.agentIndex + this.state.agentName).style.display = "";
    }

  }

  okClickHandler = () => {

    const { formerIdInfo } = this.getFormerIdAndAccounts();
    const isFormerCorrectionFlow = formerIdInfo ? true : false;


    if (this.getLOB() === "agent") {
      //if the modal opened for agent, do nothing.
      this.cancelClickHandler();
      return;
    }

    //process here.
    const { categoryId, elementId, elementName } = this.state.data;

    this.props.handleModalState(false);
    if (isFormerCorrectionFlow) {
      this.props.submitCorrectibleFormer(categoryId, elementId, elementName, this.state.selectedFormerAccount[0])
        .then(() => {
          if (!this.props.errorInfo) {
            this.setState(prevState => ({
              showRepModal: false,
              data: { ...prevState.data, requestStatus: "Request in-progress" },
              editedElements: [...prevState.editedElements, categoryId + ":" + elementId + "-" + elementName],
              selectedFormerAccount: [...prevState.selectedFormerAccount]
            }));
          }
          else {
            this.setState(prevState => ({
              showRepModal: false,
              data: { ...prevState.data, requestStatus: "" },
              editedElements: [...prevState.editedElements],
              selectedFormerAccount: [...prevState.selectedFormerAccount]
            }));
          }
        });
      return;
    }


    this.props.submitCorrectible(categoryId, elementId, elementName)
      .then(() => {

        //this.props.handleModalState(false);
        if (!this.props.errorInfo) {
          this.setState(prevState => ({
            showRepModal: false,
            data: { ...prevState.data, requestStatus: "Request in-progress" },
            editedElements: [...prevState.editedElements, categoryId + ":" + elementId + "-" + elementName],
            selectedFormerAccount: [...prevState.selectedFormerAccount]
          }));
        }
        else {
          this.setState(prevState => ({
            showRepModal: false,
            data: { ...prevState.data, requestStatus: "" },
            editedElements: [...prevState.editedElements],
            selectedFormerAccount: [...prevState.selectedFormerAccount]
          }));
        }
      });

  }

  getQueryParams = () => {
    const currURL = window.location.href;
    const url = currURL.split(window.location.host)[1];
    if (url.indexOf("?") != -1) {
      const queryParams = url.split("?")[1];
      if (queryParams && queryParams.trim().length > 0) {
        const qpArr = queryParams.split("&");
        if (qpArr && qpArr.length > 0) {
          const elementIdParam = qpArr.find(qp => qp.startsWith("elementId"));
          const categoryIdParam = qpArr.find(qp => qp.startsWith("categoryId"));
          const subCategoryIdParam = qpArr.find(qp => qp.startsWith("subCategoryId"));
          const elementIdxParam = qpArr.find(qp => qp.startsWith("elementIdx"));


          let elementId = "";
          let elementIdAndElementName = "";
          if (elementIdParam && elementIdParam.trim().length > 0) {
            elementIdAndElementName = elementIdParam.split("=")[1];
            if (elementIdAndElementName && elementIdAndElementName.trim().length > 0) {
              elementId = elementIdAndElementName.split("-")[0] || "";
              if (elementId) {
                if (elementId.indexOf(":") !== -1) {
                  elementId = elementId.split(":")[1] || "";
                }
              }
            }
          }



          let categoryId = "";
          if (categoryIdParam) {
            categoryId = categoryIdParam.split("=")[1];
          }

          let subCategoryId = -1;
          if (subCategoryIdParam) {
            subCategoryId = parseInt(subCategoryIdParam.split("=")[1]);
          }

          let elementIdx = -1;
          if (elementIdxParam) {
            elementIdx = parseInt(elementIdxParam.split("=")[1]);
          }


          const formerIdParam = qpArr.find(qp => qp.startsWith("former-id"));
          let formerId = "";
          if (formerIdParam) {
            formerId = formerIdParam.split("=")[1];
          }


          return {
            elementIdx,
            elementId,
            categoryId,
            subCategoryId,
            formerId
          }
        }
      }
    }
    return {
      elementIdx: -1,
      elementId: "",
      categoryId: "",
      subCategoryId: -1,
      formerId: ""
    };
  }

  getLOB = () => {
    const lob = checkAMLob()
    if ("vzw" === lob && "prepay" === window.reactGlobals.amRole) {
      return "prepay";
    }
    else if ("vzw" === lob) {
      return "postpay";
    }
    else if ("vzt" === lob) {
      return "wln";
    }
    return lob;
  }

  handleAccountChange = (event) => {
    const selectedAccountIdx = parseInt(event.target.value);
    const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();
    if (formerIdInfo && accountList) {
      const selectedAccount = accountList.filter((accountInfo, idx) => idx === selectedAccountIdx);
      this.setState(prevState => ({
        showRepModal: prevState.showRepModal,
        data: { ...prevState.data, ...prevState.requestStatus },
        editedElements: [...prevState.editedElements],
        selectedFormerAccount: [...selectedAccount],
        selectedFormerBox: true
      }));

    }
  }

  canceSelectedBoxCall = () => {
    this.setState({
      selectedFormerBox: false
    })
  }

  getFormerIdAndAccounts = () => {
    const formerIdInfo = window.reactGlobals.formerAcctsInfo ? window.reactGlobals.formerAcctsInfo.formerId : "";
    let accountList = [];
    if (formerIdInfo) {
      accountList = window.reactGlobals.formerAcctsInfo.accountInfo ? window.reactGlobals.formerAcctsInfo.accountInfo : [];
    }
    return {
      formerIdInfo,
      accountList
    };
  }

  showButton = (elementIdxPos, name) => {
    this.setState({
      agentIndex: elementIdxPos,
      agentName: name.split(' ').join('')
    })
  }


  handleRequestHistoryClick = () => {
    const queryString = window.location.search;
    let currentPageName = window.location.pathname + queryString;
    const { formerIdInfo } = this.getFormerIdAndAccounts();
    const isFormerCorrectionFlow = formerIdInfo ? true : false;
    const route = "/privacy/your-data/request-history"
    let pageLink;
    pageLink = [
      { requestStatusPageName: currentPageName },
      { requestHistoryPageName: route },
      { isSelectBox: isFormerCorrectionFlow },
    ]
    this.props.breadcrumbsLink(pageLink)
    this.props.history.push(route, {
      nextRoute: "/privacy/your-data/former-customer",
      PreviouspageName: currentPageName
    });
  }

  render() {
    const { formerIdInfo, accountList } = this.getFormerIdAndAccounts();

    const isFormerCorrectionFlow = formerIdInfo ? true : false;

    if (this.props.loadingInfo && !this.state.selectedFormerBox) {
      return <RectangleLoader />;
    }


    const { elementIdx, elementId, categoryId, subCategoryId, formerId } = this.getQueryParams();
    const repFlowCategoryId = this.state.data ? this.state.data.categoryId : "";
    const repFlowSubCategoryId = this.state.data && parseInt(this.state.data.subCategoryId);
    const repFlowElementId = this.state.data ? this.state.data.elementId : "";
    const repFlowElementIdx = this.state.data ? this.state.data.elementIdx : -1;

    const agentEditedElementId = this.state.authorizedAgentEditedElementId;
    const agentEditedElementIdCategory = this.state.authorizedAgentEditedElementIdCategory;
    const agentEditedElementIdSubCategory = this.state.authorizedAgentEditedElementIdSubCategory;

    const lob = this.getLOB();

    const isAgentCorrectionFlow = "agent" === lob ? true : false;

    let topOfPage = "";
    let middleOfPage = "";
    let repFlowModalContent = "";
    if (true === isFormerCorrectionFlow) {
      topOfPage = this.props.pageContent[2];
      middleOfPage = this.props.pageContent[3];
      repFlowModalContent = this.props.pageContent[4]

    }
    else if (true === isAgentCorrectionFlow) {

      if (!this.props.location.state || !this.props.location.state.confirmAuth) {
        return <Redirect to="/privacy/secure/authorized-agent" />;
      }


      topOfPage = this.props.pageContent.agentcorrection;
      middleOfPage = this.props.pageContent.agentcorrection;
      repFlowModalContent = {
        "Category": [
          {
            "category_description": middleOfPage["Category"][0].category_description,
            "category_id": middleOfPage["Category"][0].category_id,
            "category_name": middleOfPage["Category"][0].category_name
          }
        ],
        "buttons": middleOfPage["buttons"]
      };

    }
    else {
      const {
        sections: [
          [
            topOfPageInfo,
            middleOfPageInfo,
          ]
        ]
      } = this.props.pageContent;
      topOfPage = topOfPageInfo;
      middleOfPage = middleOfPageInfo;
      repFlowModalContent = this.props.pageContent.sections[2]["rep_active_corrected"];
      
    }

    let elementIdInfo = "";
    if (elementId && elementId.trim().length > 0) {
      elementIdInfo = elementId;
    }
    else if (repFlowElementId && repFlowElementId.trim().length > 0) {
      elementIdInfo = repFlowElementId
    }
    else if (agentEditedElementId && agentEditedElementId.trim().length > 0) {
      elementIdInfo = agentEditedElementId
    }

    let categoryIdInfo = "";
    if (categoryId && categoryId.trim().length > 0) {
      categoryIdInfo = categoryId;
    }
    else if (repFlowCategoryId && repFlowCategoryId.trim().length > 0) {
      categoryIdInfo = repFlowCategoryId
    }
    else if (isFormerCorrectionFlow) {
      categoryIdInfo = "accountinfo";
    }
    else if (agentEditedElementIdCategory && agentEditedElementIdCategory.trim().length > 0) {
      categoryIdInfo = agentEditedElementIdCategory;
    }


    let subCategoryIdInfo = -1;
    if (subCategoryId !== -1) {
      subCategoryIdInfo = subCategoryId;
    }
    else if (repFlowSubCategoryId !== -1) {
      subCategoryIdInfo = repFlowSubCategoryId;
    }
    else if (agentEditedElementIdSubCategory !== -1) {
      subCategoryIdInfo = agentEditedElementIdSubCategory;
    }



    let elementIdxInfo = -1;
    if (elementIdx !== -1) {
      elementIdxInfo = elementIdx;
    }
    else if (repFlowElementIdx !== -1) {
      elementIdxInfo = repFlowElementIdx;
    }

    const requestStatusInfo = this.state.data && this.state.data.requestStatus ? this.state.data.requestStatus : "";

    let mobileNumber = "";
    let notificationMethod = "";
    if (isAgentCorrectionFlow) {
      mobileNumber = this.props.location.state && this.props.location.state.agentSelectedCustomer && this.props.location.state.agentSelectedCustomer.mtn ? this.props.location.state.agentSelectedCustomer.mtn : "";
      notificationMethod = window.reactGlobals.agentInfo && window.reactGlobals.agentInfo.agentEmailId ? window.reactGlobals.agentInfo.agentEmailId : "";
    }
    
    return (
      <Fragment>
        {this.props.errorInfo ? (
          <AlertBanner alertType="error" disableAnimation>
            {convertStringToElements(this.props.errorInfo)}
          </AlertBanner>
        ) : null}

        <Container style={{ marginTop: "0", paddingTop: "0" }}>
          <SubContainer>
          <TitleLockup 
            surface='light'
            textAlignment='left'
            data={{
              title:{
                size: 'titleXLarge',
                bold: false,
                children: <H1>{convertStringToElements(topOfPage.section_title_correctible)}</H1>
              },
              subtitle:{
                size: 'bodyLarge',
                children: 
                <HeaderDesc>{convertStringToElements(topOfPage.section_description_correctible)}
                {isFormerCorrectionFlow ?
                  <TextLink
                  type="inline"
                  size="large"                 
                  onClick={this.handleRequestHistoryClick}
                  >
                    {topOfPage.section_prepayDescription}
                  </TextLink>
                  : null}
              </HeaderDesc>
              }
          }}  
          />
           
         <Dropdowndiv>
            {isFormerCorrectionFlow && (
              <DropdownSelect               
               onChange={(e) => this.handleAccountChange(e)}
              >
                {
                  accountList.map((accountInfo, idx) => (
                    <option key={accountInfo.billingAccountNumber + "_" + accountInfo.indicator + "_" + idx} value={idx}>
                      {accountInfo.firstName} {accountInfo.lastName}: {accountInfo.billingAccountNumber}
                    </option>
                  ))
                }
              </DropdownSelect>
            )}
            </Dropdowndiv>

            <div style={{ maxWidth: "712px" }}>
              <Accordion
                topLevelCategories={middleOfPage.categories}
                subLevelCategories={this.props.correctible}
                fetchCorrectible={this.props.fetchCorrectible}
                fetchCorrectibleFormer={this.props.fetchCorrectibleFormer}
                fetchCorrectibleAgent={this.props.fetchCorrectibleAgent}
                elementId={elementIdInfo}
                elementUpdateStatus={"Changes Saved"}
                elementUpdateStatusRep={requestStatusInfo}
                elementHistoryStatusRep={"Request in-progress"}
                lob={lob}
                categoryId={categoryIdInfo}
                subCategoryId={subCategoryIdInfo}
                elementIdx={elementIdxInfo}
                showRepFlowModal={this.showRepFlowModal}
                correctibleHistory={this.props.elementsData || this.props.agentCustomerHistory}
                editedElements={[...this.state.editedElements]}
                selectedFormerAccount={[...this.state.selectedFormerAccount]}
                isFormerCorrectionFlow={isFormerCorrectionFlow}
                isAgentCorrectionFlow={isAgentCorrectionFlow}
                agentSelectedMtn={isAgentCorrectionFlow ? this.props.location.state.agentSelectedCustomer.mtn : ""}
                showEditableFormForAuthorizedAgent={this.showEditableFormForAuthorizedAgent}
                showEditableForm={this.state.showEditableForm}
                authorizedAgentEditedElementId={this.state.authorizedAgentEditedElementId}
                authorizedAgentEditedElement={this.state.authorizedAgentEditedElement}
                authorizedAgentEditedElementUpdateStatus={this.state.authorizedAgentEditedElementUpdateStatus}
                submitAuthorizedAgentEditedFormData={this.submitAuthorizedAgentEditedFormData}
                showRepFlowModalForAuthorizedAgent={this.showRepFlowModalForAuthorizedAgent}
                repFlowModalForAuthorizedAgentCancelClick={this.cancelClickHandler}
                loading={this.props.loading}
                error={this.props.error}
                showEditbuttonAgent={this.showButton}
                fetchFormerRequestHistory={this.props.fetchFormerRequestHistory}
                canceSelectedBoxCall={this.canceSelectedBoxCall}
                selectedFormerBox={this.state.selectedFormerBox}
              />

              {this.props.showModal && this.state.showRepModal && (
                <RepFlowModal
                  modalContent={repFlowModalContent}
                  handleClick={this.okClickHandler}
                  handleCancelClick={this.cancelClickHandler}
                  mobileNumber={mobileNumber}
                  notificationMethod={notificationMethod}

                />
              )}

            </div>
          </SubContainer>
        </Container>
      </Fragment>
    )

  }

}

const mapStateToProps = ({
  userCorrectibleReducer: { correctible, loading, error },
  loadingAndErrorState: { loading: loadingInfo, error: errorInfo },
  pageContent,
  modalState,
  requestHistory: { elementsData },
  agentSelectedCustomer,
  agentCustomerHistory: {
    elementsData: agentCustomerHistory,
  },
  form
}) => ({
  correctible,
  loading,
  error,
  loadingInfo,
  errorInfo,
  pageContent,
  showModal: modalState.showModal,
  elementsData,
  agentSelectedCustomer,
  agentCustomerHistory,
  form
});

CorrectibleData.propTypes = {
  fetchCorrectible: PropTypes.func.isRequired,
  fetchCorrectibleFormer: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  correctible: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  formerandGuestCloseCaseId: PropTypes.func.isRequired,
  breadcrumbsLink: PropTypes.func.isRequired,

};

export default compose(
  connect(
    mapStateToProps,
    { fetchCorrectible, fetchCorrectibleFormer, fetchCorrectibleAgent, submitCorrectible, submitCorrectibleForAuthorizedAgent, submitCorrectibleFormer, setA11yContent, setBreadcrumbList, handleModalState, fetchRequestHistory, fetchCustomerHistory, formerandGuestCloseCaseId, fetchFormerRequestHistory, breadcrumbsLink }
  ),
  FetchPageContent
)(CorrectibleData);

const Container = styled.div`
  margin: "0px 0px 0px 20px"};
  padding: 64px 20px ;  
  ${media.mobile`
    margin: "0";
    padding: 48px 16px ;
  `}
`;

const SubContainer = styled.div`
  padding: 0 20px;

  ${media.mobile`
    padding: 0 16px;
  `};
`;

const HeaderDesc = styled.div`
  margin-bottom: 35px;
  max-width: 596px;

  p,
  a {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
    width: 100%;

    ${media.mobile`
      font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.5px;
      width: 100%;
    `}
  }
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 596px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding: 67px 0px 32px 0px;
  font-weight:300;

  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  `}
`;

const Dropdowndiv = styled.div`
  width: 332px !important;
  padding: 12px !important;
  min-width: inherit !important;
  height: inherit !important;
  margin-bottom: 10px;
  
  ${media.mobile`    
    max-width: 100%;
      
  `}
`;

// const RequestHistoryButton = styled.div`
 
//     background: transparent;
//     border: none;
//     text-decoration: underline;
//     font-size: 16px;
//     line-height: 20px;
//     font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
//     font-weight: 400;
//     cursor: pointer;
  
// `;